import { useContext } from 'react';
import SettingsContext from 'hooks/SettingsContext';


const useSettings = () => useContext(SettingsContext);

export default useSettings;
